export function initKeyboardNavigation() {
  function handleKeydown(e) {
    if (e.key === 'Tab') {
      document.body.classList.add('a11y-keyboard-nav');
    }
  }
  function handleMouseDown() {
    document.body.classList.remove('a11y-keyboard-nav');
  }
  document.addEventListener('keydown', handleKeydown);
  document.addEventListener('mousedown', handleMouseDown);
  document.addEventListener('touchstart', handleMouseDown);
  return () => {
    document.removeEventListener('keydown', handleKeydown);
    document.removeEventListener('mousedown', handleMouseDown);
    document.removeEventListener('touchstart', handleMouseDown);
  };
}

export function handleEscape(callback) {
  function handler(e) {
    if (e.key === 'Escape') {
      callback(e);
    }
  }
  document.addEventListener('keydown', handler);
  return () => document.removeEventListener('keydown', handler);
}

export function handleEnterSpace(element, callback) {
  element.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      callback(e);
    }
  });
}
